import { c as _c } from "react/compiler-runtime";
import Subsection from '../../../../../subsection';
import type { BusinessInsightDisplayOptions } from '../../../../onboarding-business-insight';
import type { FormattedDetails, FormattedName } from '../../../../onboarding-business-insight.types';
import BusinessNameList from './components/business-name-list';
import OtherBusinessDetails from './components/other-business-details';
type BusinessDetailsProps = {
  names: FormattedName[];
  details: FormattedDetails;
  onClick: (registrationId: string) => void;
  displayOptions?: BusinessInsightDisplayOptions;
};
const BusinessDetails = t0 => {
  const $ = _c(9);
  const {
    names,
    details,
    onClick,
    displayOptions
  } = t0;
  let t1;
  if ($[0] !== displayOptions || $[1] !== names || $[2] !== onClick) {
    t1 = <BusinessNameList data={names} onOpen={onClick} displayOptions={displayOptions} />;
    $[0] = displayOptions;
    $[1] = names;
    $[2] = onClick;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== details) {
    t2 = <OtherBusinessDetails data={details} />;
    $[4] = details;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <Subsection><div className="flex flex-col gap-6">{t1}{t2}</div></Subsection>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default BusinessDetails;